module.exports = function(posts) {
	'use strict'
	posts.directive('tagEditDir',tagEditDir);
	tagEditDir.$inject=[];
	function tagEditDir() {
		return {
			template: require('./partial/tag-edit.html'),
			controller:'tagEditController',
			controllerAs:'vmte',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/tag-edit/js/directive/tagEditDirective.js
// module id = 568
// module chunks = 0